import {
  SET_APP_LANGUAGE,
  SET_LOGIN_DETAILS,
  SET_SESSION_EXPIRED,
  SET_USER_DETAILS,
  SET_ROLE_ACCESS_DETAILS,
  SET_COMPANY_DETAILS,
  SET_PROFILE_IMAGE_DETAILS,
  SET_MENU_DETAILS,
  SET_SUB_ROLE_ACCESS_DETAILS,
  SET_ROLE_ACCESS_KEY,
  SET_ACCOUNT_LIST,
  SET_CURRENT_ACC_DETAILS,
  SET_ACCOUNT_REFRESH,
  SET_OFFERS,
  SET_BILLERS_LIST,
  SET_FEATURE_LIST,
  SET_MENU_LIST
} from '../constants'

export const setAppLanguage = (payload) => ({
  type: SET_APP_LANGUAGE,
  payload,
})
export const setLoginDetails = (payload) => ({
  type: SET_LOGIN_DETAILS,
  payload,
})
export const setUserDetails = (payload) => ({
  type: SET_USER_DETAILS,
  payload,
})
export const setRoleAccessDetails = (payload) => ({
  type: SET_ROLE_ACCESS_DETAILS,
  payload,
})

export const setSubRoleAccessDetails = (payload) => ({
  type: SET_SUB_ROLE_ACCESS_DETAILS,
  payload,
})
export const setCompanyDetails = (payload) => ({
  type: SET_COMPANY_DETAILS,
  payload,
})
export const setProfileImageDetails = (payload) => ({
  type: SET_PROFILE_IMAGE_DETAILS,
  payload,
})
export const setMenuDetails = (payload) => ({
  type: SET_MENU_DETAILS,
  payload,
})
export const setIsSessionExpired = (payload) => ({
  type: SET_SESSION_EXPIRED,
  payload,
})

export const setRoleAccessKey = (payload) => ({
  type: SET_ROLE_ACCESS_KEY,
  payload,
})

export const setAccounts = (payload) => ({
  type: SET_ACCOUNT_LIST,
  payload,
})

export const setCurrentAccDetails = (payload) => ({
  type: SET_CURRENT_ACC_DETAILS,
  payload,
})

export const setIsAcctRefresh = (payload) => ({
  type: SET_ACCOUNT_REFRESH,
  payload,
})

export const setOffers = (payload) => ({
  type: SET_OFFERS,
  payload,
})

export const setBillersList = (payload) => ({
  type: SET_BILLERS_LIST,
  payload,
})

export const setFeatureList = (payload) => ({ type: SET_FEATURE_LIST, payload })

export const setMenuList = (payload) => ({ type: SET_MENU_LIST, payload })